<template>
    <div class="rw-table-filters">
        <div data-toggle="tooltip" data-placement="top" title="Filtra per tipologia pesatura"
            class="single--list-view single--list-view-employees rw-table-filter-type">
            <span class="pre-filter-label">Filtri</span>
            <vs-select class="selectExample" v-model="filters.filterType" @input="filterTypeSelected">
                <vs-select-item :is-selected="item.isSelected" :key="index" :value="item.value" :text="item.label"
                    v-for="(item, index) in optionsFilterType" />
            </vs-select>
        </div>

        <div class="rw-table-filter-select" v-for="filter in organizationalFilters" :key="filter.key">
            <label class="rw-table-filter-label">{{ filter.label }}</label>
            <div class="rw-table-filter-dropdown" v-click-outside="() => closeDropdown(filter.key)">
                <button type="button" class="rw-table-filter-trigger" @click="toggleDropdown(filter.key)">
                    <span>{{ displayText(filter) }}</span>
                    <i class="fas fa-chevron-down" :class="{ 'fa-rotate-180': openDropdown === filter.key }"></i>
                </button>

                <div v-if="openDropdown === filter.key" class="rw-table-filter-menu">
                    <div class="rw-table-filter-search">
                        <input type="text" class="form-control" v-model="searchTerms[filter.key]"
                            :placeholder="__('forms.Equity.role_weighting_page.search_placeholder')"
                            @click.stop>
                    </div>

                    <div class="rw-table-filter-options">
                        <button v-for="option in filteredOptions(filter)" :key="option.id" type="button"
                            class="rw-table-filter-option" @click="toggleOption(filter.key, option.id)">
                            <span class="rw-table-filter-check">
                                <i v-if="filters[filter.key].includes(String(option.id))" class="fas fa-check"></i>
                            </span>
                            <span>{{ option.name }}</span>
                        </button>

                        <div v-if="filteredOptions(filter).length === 0" class="rw-table-filter-empty">
                            {{ __('forms.Equity.role_weighting_page.no_roles_found') }}
                        </div>
                    </div>

                    <button v-if="filters[filter.key].length > 0" type="button" class="rw-table-filter-clear"
                        @click="clearFilter(filter.key)">
                        Deseleziona tutto
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    directives: {
        clickOutside: {
            bind(el, binding) {
                el.__clickOutsideHandler__ = event => {
                    if (!(el === event.target || el.contains(event.target))) {
                        binding.value(event);
                    }
                };
                document.addEventListener('mousedown', el.__clickOutsideHandler__);
            },
            unbind(el) {
                document.removeEventListener('mousedown', el.__clickOutsideHandler__);
            }
        }
    },
    props: {
        companies: {
            type: Array,
            default: () => []
        },
        organizationalUnits: {
            type: Array,
            default: () => []
        },
        roles: {
            type: Array,
            default: () => []
        },
        selectedCompanyFilter: {
            type: Array,
            default: () => []
        },
        selectedOrganizationalUnitFilter: {
            type: Array,
            default: () => []
        },
        selectedRoleFilter: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            filters: {
                filterType: /filterType=([^&]+)/.exec(location.href) == null ? "all" : decodeURIComponent(/filterType=([^&]+)/.exec(location.href)[1]),
                companyFilter: this.selectedCompanyFilter.map(String),
                organizationalUnitFilter: this.selectedOrganizationalUnitFilter.map(String),
                roleFilter: this.selectedRoleFilter.map(String),
            },
            searchTerms: {
                companyFilter: '',
                organizationalUnitFilter: '',
                roleFilter: '',
            },
            openDropdown: null,
            optionsFilterType: [
                { value: 'all', label: this.__('forms.Equity.role_weighting_page.all_roles'), isSelected: false },
                { value: 'with_weighting', label: this.__('forms.Equity.role_weighting_page.roles_with_weighting'), isSelected: false },
                { value: 'without_weighting', label: this.__('forms.Equity.role_weighting_page.roles_without_weighting'), isSelected: false },
            ],
        }
    },
    computed: {
        organizationalFilters() {
            return [
                {
                    key: 'companyFilter',
                    label: this.__('forms.Equity.role_weighting_page.filter_by_company'),
                    options: this.companies,
                },
                {
                    key: 'organizationalUnitFilter',
                    label: this.__('forms.Equity.role_weighting_page.filter_by_org_unit'),
                    options: this.organizationalUnits,
                },
                {
                    key: 'roleFilter',
                    label: this.__('forms.Equity.role_weighting_page.filter_by_role'),
                    options: this.roles,
                },
            ];
        }
    },
    methods: {
        filterTypeSelected(selectedOption) {
            this.filters.filterType = selectedOption;
            this.applyFilters();
        },
        toggleDropdown(key) {
            this.openDropdown = this.openDropdown === key ? null : key;
            if (this.openDropdown) {
                this.searchTerms[key] = '';
            }
        },
        closeDropdown(key) {
            if (this.openDropdown === key) {
                this.openDropdown = null;
            }
        },
        toggleOption(key, optionId) {
            const normalizedId = String(optionId);
            if (this.filters[key].includes(normalizedId)) {
                this.filters[key] = this.filters[key].filter(id => id !== normalizedId);
            } else {
                this.filters[key] = [...this.filters[key], normalizedId];
            }

            this.applyFilters();
        },
        clearFilter(key) {
            this.filters[key] = [];
            this.applyFilters();
        },
        filteredOptions(filter) {
            const searchTerm = (this.searchTerms[filter.key] || '').toLowerCase();

            if (!searchTerm) {
                return filter.options;
            }

            return filter.options.filter(option => option.name.toLowerCase().includes(searchTerm));
        },
        displayText(filter) {
            const selected = this.filters[filter.key];

            if (selected.length === 0) {
                return this.__('forms.Equity.role_weighting_page.show_all');
            }

            if (selected.length === 1) {
                const selectedOption = filter.options.find(option => String(option.id) === selected[0]);
                return selectedOption ? selectedOption.name : this.__('forms.Equity.role_weighting_page.show_all');
            }

            return `${selected.length} selezionati`;
        },
        applyFilters() {
            this.updateUrl();
            const params = {
                filterType: this.filters.filterType,
                companyFilter: this.filters.companyFilter,
                organizationalUnitFilter: this.filters.organizationalUnitFilter,
                roleFilter: this.filters.roleFilter,
            };

            window.dispatchEvent(new CustomEvent('vuetable:update-params', {
                detail: {
                    componentFiltersName: 'role-weighting-filters',
                    params,
                }
            }));

            if (window.Livewire) {
                window.Livewire.emit('refreshWithOrganizationalFilters', params);
            }
        },
        updateUrl() {
            const url = new URL(window.location.href);
            url.searchParams.set('filterType', this.filters.filterType);

            ['companyFilter', 'organizationalUnitFilter', 'roleFilter'].forEach(filterName => {
                Array.from(url.searchParams.keys()).forEach(key => {
                    if (key === filterName || key.indexOf(`${filterName}[`) === 0) {
                        url.searchParams.delete(key);
                    }
                });

                this.filters[filterName].forEach(value => {
                    url.searchParams.append(`${filterName}[]`, value);
                });
            });

            window.history.replaceState({}, '', url.toString());
        }
    },
    mounted() {
        this.optionsFilterType.forEach(option => {
            option.isSelected = option.value === this.filters.filterType;
        });
    }
}
</script>

<style scoped>
.rw-table-filters {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    flex-wrap: wrap;
}

.rw-table-filter-type {
    margin-right: 4px;
}

.rw-table-filter-select {
    min-width: 210px;
}

.rw-table-filter-label {
    display: block;
    margin-bottom: 4px;
    color: #0d6eaa;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
}

.rw-table-filter-dropdown {
    position: relative;
}

.rw-table-filter-trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 38px;
    padding: 8px 12px;
    border: 1px solid #dde5ec;
    border-radius: 8px;
    background: #fff;
    color: #333;
    text-align: left;
}

.rw-table-filter-menu {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    z-index: 1050;
    width: 100%;
    min-width: 240px;
    border: 1px solid #dde5ec;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0 8px 20px rgba(20, 49, 72, 0.15);
}

.rw-table-filter-search {
    padding: 8px;
    border-bottom: 1px solid #eef2f5;
}

.rw-table-filter-options {
    max-height: 220px;
    overflow-y: auto;
    padding: 4px 0;
}

.rw-table-filter-option {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 7px 10px;
    border: 0;
    background: transparent;
    color: #333;
    text-align: left;
}

.rw-table-filter-option:hover {
    background: #f5f8fa;
}

.rw-table-filter-check {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    color: #0d6eaa;
}

.rw-table-filter-empty {
    padding: 12px;
    color: #999;
    text-align: center;
}

.rw-table-filter-clear {
    width: 100%;
    padding: 8px;
    border: 0;
    border-top: 1px solid #eef2f5;
    background: #fff;
    color: #0d6eaa;
}
</style>
